import * as React from "react";
import * as _ from "lodash";
import { connect } from "react-redux";
import { IPatientDetail } from "@curefit/care-common";
import { PatientCompleteInfoActions } from "../../actions/PatientCompleteInfoActions";
import * as RoutesConfig from "../../routes";
import { IAppState } from "../../models/IAppState";
import ILabTestMaster from "../../models/ILabTestMaster";
import AppUtils, { LOADING_STATE } from "../../utils/AppUtils";
import AllLabTestsContainer from "../../components/AllLabTestsContainer";
import AppLoader from "../../components/utils/AppLoader";
import { EventNames } from "../../utils/EventTrackerConstants";
import { OngoingConsultationActions } from "../../actions/OngoingConsultationActions";
import CovidAssessmentRecords from "../CovidAssessmentRecords";
import { Card } from "@curefit/pandora";

/**
 * Created by abhinav on 28/01/18.
 */


interface PatientLabTestsContainerProps {
    params: any;
    patientProfile: IPatientDetail;
    labTests: ILabTestMaster[];
    fetchPatientLabTests: (patientId: number) => Promise<any>;
    getIsActiveCovidPack: (userId: number) => Promise<any>;
    isCovidActivePack: boolean;
}


interface PatientLabTestsContainerState {
    loadingState: LOADING_STATE
}

class PatientLabTestsContainer extends React.Component<PatientLabTestsContainerProps, PatientLabTestsContainerState> {
    private loadStartTime: number = AppUtils.getCurrentTime()
    constructor(props: PatientLabTestsContainerProps) {
        super(props);
        this.state = {
            loadingState: LOADING_STATE.NOT_INITIALIZED
        }
    }

    getPatientId = () => {
        return parseInt(this.props.params[RoutesConfig.PATIENT_ID_PARAM]);
    }

    getCurefitUserId = () => {
        return this.props.patientProfile.curefitUserId;
    }

    componentWillReceiveProps(newProps: PatientLabTestsContainerProps) {
        if (!_.isNull(newProps.labTests) && this.state.loadingState === LOADING_STATE.LOADING) {
            this.setState({
                loadingState: LOADING_STATE.LOADED
            })
        }
    }

    componentDidMount() {
        if (this.props.patientProfile) {
            this.props.getIsActiveCovidPack(Number(this.props.patientProfile.curefitUserId))
        }
        if (_.isNull(this.props.labTests)) {
            this.setState({
                loadingState: LOADING_STATE.LOADING
            })
            this.props.fetchPatientLabTests(this.getPatientId()).then(() => {
                AppUtils.updatePageLoadEvent(EventNames.All_Labs, "", this.loadStartTime)
            });
        }
    }

    render() {
        let labTests = !_.isEmpty(this.props.labTests) ? this.props.labTests : null;
        return (
            <div className="patient-AllLabtests-container patient-info-section">
                {/* <Card>
                    <div className="patient-section-header">Lab Tests</div>
                </Card> */}
                {this.props.isCovidActivePack && (
                    <CovidAssessmentRecords
                        curefitUserId={Number(this.props.patientProfile.curefitUserId)}
                        patientId={this.props.params.patientId}
                    />
                )}
                {
                    this.state.loadingState === LOADING_STATE.LOADING &&
                    <AppLoader />
                }
                {
                    this.state.loadingState !== LOADING_STATE.LOADING &&
                    <AllLabTestsContainer labTests={labTests} userId={this.getCurefitUserId()} />
                }
            </div>
        );
    }
}


function mapStateToProps(state: IAppState, ownProps: any): any {
    return {
        labTests: state.patientCompleteInfo.labTests,
        patientProfile: state.patientCompleteInfo.profile,
        isCovidActivePack: state.covidInfo.isCovidActivePack
    };
}

function mapDispatchToProps(dispatch: any): any {
    return {
        fetchPatientLabTests: (patientId: number) => {
            return PatientCompleteInfoActions.fetchPatientLabTests(dispatch, patientId);
        },
        getIsActiveCovidPack: (userId: number) => {
            return OngoingConsultationActions.getIsActiveCovidPack(dispatch, userId)
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientLabTestsContainer);